<template lang="html">
    <div class="row">
        <div class="col-12 grid-margin">
            <multiselect v-model="value" 
                         tag-placeholder="Add this as new tag" 
                         placeholder="Choose categories" 
                         label="name" track-by="code" 
                         :options="options" 
                         :multiple="true" 
                         :taggable="true" 
                         @tag="addTag">
            </multiselect>
        </div>
        <div class="col-12 grid-margin">
            <div class="card">
                <div class="card-body">
                    <h5 class="card-title mb-4">Items</h5>
                    <div class="table-responsive">
                        <table class="table center-aligned-table">
                            <thead>
                                <tr>
                                    <th class="border-bottom-0">No.</th>
                                    <th class="border-bottom-0">Name</th>
                                    <th class="border-bottom-0">Price</th>
                                    <th class="border-bottom-0">Category</th>
                                    <th class="border-bottom-0">
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(i, index) in itemsFromRepository">
                                    <td> {{ index + 1 }} </td>
                                    <td> {{ i.itemName }} </td>
                                    <td> {{ i.originalPrice }} </td>
                                    <td> {{ i.category }} </td>
                                    <td>
                                        <b-form-checkbox v-on:input="handleItemCheckedBox($event, i)"
                                                         v-model="i.isChecked">
                                        </b-form-checkbox>  
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>      
    </div>
</template>

<script lang="js">
import Multiselect from 'vue-multiselect'
import { mapActions, mapState, mapGetters } from'vuex'
export default{
    name: 'itemssearch',
    inject: ['eventBus'],
    components: {
        Multiselect
    },
    data () {
        return {
            selectedItems:  [],
            value: [],
            options: []
      }
    },
    computed: {
        ...mapState({
          itemsFromRepository: state => state.itemssearch.itemsFromRepository
      })
    },
    methods: {
        addTag (newTag) {
            const tag = {
                name: newTag,
                code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
            }
            this.options.push(tag);
            this.value.push(tag);
        },
        handleItemCheckedBox(event, item) {
            if (event === true) {
                item.isChecked === true;
            }
            else {
                item.isChecked === false;
            }
        },
        handleOnNextEvent() {
          this.$store.dispatch('menus/setMenuItemsAction', this.itemsFromRepository);
        },
        handleOnBackEvent() {

        }
  },
    async created() {
        await this.$store.dispatch('restaurants/getRestaurantsAction');
        await this.$store.dispatch('itemssearch/getCategoriesFromRepositoryAction');
        await this.$store.dispatch('itemssearch/getItemsFromRepositoryAction');
        this.options = this.$store.state.itemssearch.categoriesFromRepository;
        
    },
    mounted() {
        this.eventBus.$on('onNextEvent', this.handleOnNextEvent);
        this.eventBus.$on('onBackEvent', this.handleOnBackEvent);
    },
    destroyed() {
        this.eventBus.$off('onNextEvent', this.handleOnNextEvent);
        this.eventBus.$off('onBackEvent', this.handleOnBackEvent);
    }
}
</script>

<style lang="scss">
   
</style>